import { useTranslation } from "react-i18next";
import { type IFakePayment } from "@services/payments/types";
import { formatPrice } from "@utils/units";

interface IFakePaymentInformationCardProps {
  paymentData: IFakePayment;
}

export const FakePaymentInformationCard: React.FC<
  IFakePaymentInformationCardProps
> = (props) => {
  const { paymentData } = props;
  const { t } = useTranslation();

  return (
    <div className="flex flex-col gap-4 rounded-2xl border border-grey-light bg-base-white px-4 py-5 shadow-sm">
      <div className="flex flex-col">
        <span className="break-all text-lg font-semibold text-base-black">
          {t("fakePaymentInformation.title")}
        </span>
        <span>
          <b>{t("fakePaymentInformation.amount")}: </b>
          {formatPrice(paymentData.totalAmount)}
        </span>
        <span>
          <b>{t("fakePaymentInformation.description")}: </b>
          {paymentData.description}
        </span>
        <span>
          <b>{t("fakePaymentInformation.taxCollectorName")}: </b>
          {paymentData.taxCollectorName}
        </span>
      </div>
      <div className="flex flex-col gap-2">
        <span>
          <b>{t("fakePaymentInformation.paymentDetails")}:</b>
        </span>
        <div className="flex flex-col gap-4">
          {paymentData.fakePaymentDetails.map((detail) => (
            <div>
              <span>
                <b className="text-lg">{detail.jointBillServiceAdress}</b> (
                {detail.jointBillServiceId})
              </span>
              <span className="px-3 text-grey-light">|</span>
              <span>
                <b>{t("fakePaymentInformation.amount")}: </b>
                {formatPrice(detail.amount)}
              </span>
              <span className="px-3 text-grey-light">|</span>
              <span>
                <b>{t("fakePaymentInformation.period")}: </b>
                {detail.period}
              </span>
              <table className="mt-2 w-full border border-grey-light">
                <thead className="border border-grey-light bg-base-light-grey">
                  <tr className="text-left text-sm font-normal text-grey-dark">
                    <th className="px-6 py-3">
                      {t("fakePaymentInformation.displayName")}
                    </th>
                    <th className="py-3">
                      {t("fakePaymentInformation.expectedAmount")}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {detail.expectedPayments.map((payment) => (
                    <tr className="border border-grey-light text-left hover:bg-base-light-grey">
                      <th className="px-6 font-medium">
                        {payment.displayName}
                      </th>
                      <td className="py-3">
                        {formatPrice(payment.expectedAmount)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
